// PERFORMANCE: Custom comparison - skip pan/zoom since they're handled via direct DOM manipulation
export default function areFlowchartCanvasPropsEqual(prevProps, nextProps) {
  const { pan: prevPan, zoom: prevZoom, ...prevRest } = prevProps;
  const { pan: nextPan, zoom: nextZoom, ...nextRest } = nextProps;

  const prevKeys = Object.keys(prevRest);
  const nextKeys = Object.keys(nextRest);

  if (prevKeys.length !== nextKeys.length) return false;

  for (const key of prevKeys) {
    if (prevRest[key] !== nextRest[key]) return false;
  }

  return true;
}
